/**
 * v2 (26/10/2026) — a copied gateway's sender IDs: they come along onto its twin (user decision:
 * "Keep them, shown in review"), listed here, and the person may clear them — the lanes then
 * arrive without sender IDs and the AI writes them with the same sender prompts.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { cn } from '@/lib/utils';

const SHOWN = 6;

interface Props {
  ids: string[];
  cleared: boolean;
  /** Only when the gateway lands somewhere — a gateway left out takes nothing along. */
  lands: boolean;
  onClear: (clear: boolean) => void;
}

export const SenderIds: FC<Props> = ({ ids, cleared, lands, onClear }) => {
  if (ids.length === 0 || !lands) return null;
  const more = ids.length > SHOWN ? ids.length - SHOWN : 0;
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-1 text-[11px]" data-testid="paste-sender-ids">
      <span className="text-muted-foreground">{cleared ? 'Sender IDs left behind:' : `Sender IDs come along (${ids.length}):`}</span>
      {ids.slice(0, SHOWN).map((id) => (
        <span key={id} className={cn('rounded border border-border/70 px-1 font-mono', cleared && 'text-muted-foreground line-through')}>
          {id}
        </span>
      ))}
      {more ? <span className="text-muted-foreground">+{more}</span> : null}
      <button type="button" onClick={() => onClear(!cleared)} className="ml-1 rounded px-1 font-medium text-primary hover:underline">
        {cleared ? 'Keep them' : 'Clear them'}
      </button>
    </div>
  );
};
